export const getDerivedProductMetrics = (product) => {
    try{
        let { attributes } = product;
        let { facet_subbrand, pm_producttype, subbrandname, plcode: category, "3211896": tppBrand } = attributes || {};

        // get brand name
        let brand = facet_subbrand || subbrandname || tppBrand || pm_producttype;

        return {
            brand,
            category: `${category}:${brand}`
        }
    }catch(e){}

    return {};
}

export const getProductClickMetrics = ({product, position, useAttributes, list }) => {
    // use listPrice for price, similar to the current a2c events
    let { name, sku, variant, listPrice} = product || {};
    let derivedProductMetrics = getDerivedProductMetrics(product);
    if(useAttributes){
        return {
            'data-metrics-event-name': 'productClick',
            'data-metrics-event': 'e_productClick',
            'data-metrics-name': name,
            'data-metrics-price': listPrice + '',
            'data-metrics-id': sku,
            ...position ? {'data-metrics-position': position + ''} : {}, // starts at 1, can never be 0
            ...derivedProductMetrics.brand ? {'data-metrics-brand': derivedProductMetrics.brand } : {},
            ...derivedProductMetrics.category ? {'data-metrics-category': derivedProductMetrics.category} : {},
            ...variant ? {'data-metrics-variant': variant} : {},
            ...list ? {'data-metrics-list': list} : {}
        }
    }

    return {
        price: listPrice + '',
        name, 
        id: sku,
        ...derivedProductMetrics.brand ? {brand: derivedProductMetrics.brand} : {},
        ...derivedProductMetrics.category ? {category: derivedProductMetrics.category} : {},
        ...variant ? {variant} : {},
        ...position ? {position: position + ''} :{},
        ...list ? {list} : {}
    }


}